<template>
  <v-app id="inspire">
    <v-snackbar color="error" top v-model="snackbar">
      {{ snackbarText }}
      <v-btn @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" md="4">
            <v-card
              class="elevation-0"
              style="border: 1px solid rgb(224 224 224)"
            >
              <v-card-title>
                <div>
                  <v-img
                    width="195px"
                    src="../../src/assets/logoLogin.png"
                  ></v-img>
                </div>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="form" v-model="valid" validation>
                  <v-text-field
                    :rules="[(v) => !!v || 'Логин обязательный']"
                    @keyup.enter="loginBtn"
                    id="email"
                    label="Логин"
                    name="login"
                    required
                    type="text"
                    v-model="login"
                    outlined
                    class="mr-5 ml-5 mt-5"
                  ></v-text-field>
                  <v-text-field
                    :rules="[(v) => !!v || 'Пароль обязательный']"
                    @keyup.enter="loginBtn"
                    id="password"
                    label="Пароль"
                    name="password"
                    required
                    outlined
                    type="password"
                    v-model="password"
                    class="mr-5 ml-5"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions style="height: 65px">
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="!valid"
                  @click="loginBtn"
                  class="mr-6 mb-6 caption button-accept"
                  >Войти
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    valid: false,
    login: "",
    password: "",
    snackbar: false,
    snackbarText: "",
  }),
  created() {},
  methods: {
    // loginBtn() {
    //   if (this.$refs.form.validate()) {
    //     let body = {
    //       login: this.login,
    //       password: this.password
    //     };

    //     this.$axios.post(this.$store.getters.apiAdminPanelV1 + '/login', body)
    //       .then(res => {
    //         this.$cookies.set(this.$store.state.adminPanelKeyCookie, res.data.accessToken)
    //         if (res.data.user.name) {
    //           this.$cookies.set('VTBUserName', res.data.user.name)
    //         }

    //         window.location.href = '/'
    //       }).catch(() => {
    //         this.$store.commit("errorSet", true);
    //         this.$store.commit("errorTextSet", 'Введен неверный логин или пароль');
    //       })
    //   }
    // }
    loginBtn() {
      if (this.$refs.form.validate()) {
        let body = {
          login: this.login,
          password: this.password,
        };

        const login = this.$axios.create({
          baseURL: this.$store.getters.apiAdminPanelV5,
          headers: {
            "secret-key": this.$store.state.secretKeyCookie,
          },
        });

        login.post("auth/login/panel", body)
          .then((res) => {
            this.$cookies.set(
              this.$store.state.adminPanelKeyCookie,
              res.data.accessToken
            );
            if (res.data.user?.name) {
              this.$cookies.set("VTBUserName", res.data.user.name);
            }
            window.location.href = "/";
          })
          .catch(() => {
            this.$store.commit("errorSet", true);
            this.$store.commit(
              "errorTextSet",
              "Введен неверный логин или пароль"
            );
          });
      }

      // .then(res => {
      //   this.$cookies.set(this.$store.state.adminPanelKeyCookie, res.data.accessToken)
      //   if (res.data.user.name) {
      //     this.$cookies.set('VTBUserName', res.data.user.name)
      //   }

      //   window.location.href = '/'
      // }).catch(() => {
      //   this.$store.commit("errorSet", true);
      //   this.$store.commit("errorTextSet", 'Введен неверный логин или пароль');
      // })
    },
  },
};
</script>
